module.exports = {
    companyName: "Bat in Web Maciej Szałkowski",
    address1: "Swobodna 34/27",
    address2: "15-756 Białystok",
    address3: "Polska",
}
